import { render, staticRenderFns } from "./viewFile.vue?vue&type=template&id=58bb156c&scoped=true&"
import script from "./viewFile.vue?vue&type=script&lang=js&"
export * from "./viewFile.vue?vue&type=script&lang=js&"
import style0 from "./viewFile.vue?vue&type=style&index=0&id=58bb156c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb156c",
  null
  
)

export default component.exports